<template>
  <div class="cat-file">
    <div class="fileboxheader">
      <span>{{ title }}</span>
    </div>
    <div class="fileboxmain" @click="upload">
      <template v-if="uploadFailedFlag">
        <div class="fileboxbox">
          <div class="fileboxtext" style="color:red">上传失败</div>
          <div class="fileboxtext" style="color:red">点击重试</div>
        </div>
      </template>
      <template v-else>
        <template v-if="uploadStatus==='uploading'" >
          <div class="fileboxbox">
            <van-circle v-model="currentRate" size="50px" :rate="0" :speed="100" :text="uploadingText" />
          </div>
        </template>
        <template v-else-if="uploadStatus==='uploaded'" >
          <div class="fileboxbox">
            <img :src="require(`@/assets/file.png`)" style="width:28px;height:28px" alt="" />
            <div class="fileboxtext">{{fileDetail.name}}</div>
          </div>
        </template>
        <div class="fileboxbox" v-else>
          <img :src="require(`@/assets/upload.png`)" style="width:28px;height:28px" alt="" />
          <div class="fileboxtext">点击上传</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "uploadFile",
  props: {
    title: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      fileElement: null,  //input元素
      fileValue: null,    
      currentRate: 0,    //上传进度(显示)
      uploading: false,
      uploadingProgress: 0, //上传进度
      fileDetail: {}, //上传文件的信息
      uploadFailedFlag: false,
    }
  },

  computed: {
    uploadStatus: function() {
      if(this.uploading) {
        return "uploading"  //上传中
      }else if(!this.uploading && this.uploadingProgress === 1) {
        return "uploaded"   //上传完成
      }
    },
    uploadingText() {  
      return this.currentRate.toFixed(0) + '%';
    }
  },

  watch: {
    uploadingProgress: function() {
      this.currentRate = this.uploadingProgress * 100
      if(this.uploadingProgress === 1){
        this.$emit('getFileDetail', this.fileDetail)
      }
    }
  },

  created: function() {
    window.vuefile = this
  },

  methods: {
    upload: function() { //点击上传
      if(this.uploadStatus==='uploading'){  //上传中不能点击
        return 
      }
      this.fileElement = document.createElement(`input`);
      this.fileElement.style.display = "none"
      this.fileElement.type = 'file'
      if(this.accept) {this.fileElement.accept = this.accept}
      this.fileElement.addEventListener('change', this.changeValue)
      document.body.appendChild(this.fileElement)
      this.fileElement.click()
    },
    changeValue: function() { 
      if(this.fileElement.files){
        this.uploadRequest(this.fileElement.files)
      }
    },
    uploadRequest: function(files) {
      var formData = new FormData()
      formData.append("file", files[0])
      this.fileDetail = {
        name: files[0].name,
        size: files[0].size,
        type: files[0].type
      }
      let name = this.initFileName(files[0].name)  //将文件名拆分为名字和后缀
      this.uploadFailedFlag = false
      this.uploadChunk(files[0], name[0], name[1])
    },
    uploadChunk: async function(blob, fileName, fileType){ // 初始化上传任务
      return new Promise((resolve) => {
        this.uploadingProgress = 0
        this.uploading = true
        let identifier = new Date().getTime()
        let newFileName =  `${fileName}-${identifier}.${fileType}`
        this.$http.post(this.$server.uploadChunkInit, {
          identifier, fileName: newFileName
        }).then(async res => {
          if (res.data.success) {
            this.fileDetail.uploadPath = res.data.data.resKey
            resolve(await this.uploadChunkRequest(blob, newFileName, identifier))
          } else {
            this.uploading = false
            this.uploadFailedFlag = true
            resolve()
          }
        }).catch(() => {
          this.uploading = false
          this.uploadFailedFlag = true
          resolve()
        })
      })
    },
    uploadChunkRequest: function(blob, fileName, identifier) {
      return new Promise((resolve) => {
        const chunkSize = 1024 * 1024; // 每次上传的大小
        let remainder = blob.size % chunkSize // 分块余数
        let totalChunk = Math.floor(blob.size / chunkSize)
        let totalChunks = remainder > 0 ? totalChunk + 1 : totalChunk
        let uploadedChunk = 0 // 已上传完成的块
        for (let i = 1; i <= totalChunks; i++) {
          let fd = new FormData();
          let xhr = new XMLHttpRequest();
          fd.append('chunkNumber', i);
          fd.append('chunkSize', chunkSize);
          fd.append('currentChunkSize', totalChunks === i ? remainder : chunkSize);
          fd.append('totalSize', blob.size);
          fd.append('identifier', identifier);
          fd.append('filename', fileName);
          fd.append('totalChunks', totalChunks);
          // 根据长度截取每次需要上传的数据
          fd.append('file', blob.slice((i - 1) * chunkSize, i * chunkSize));
          xhr.open('POST', this.$server.uploadChunk, true);
          xhr.setRequestHeader("Authorization",localStorage.getItem("tokenn"));
          xhr.onreadystatechange = () => { // 上传成功回调
            if (xhr.readyState === 4 && xhr.status === 200 && xhr.responseText) {
              uploadedChunk++
              if (totalChunks === uploadedChunk) {
                this.uploadingProgress = 1
                this.uploading = false
                let file = JSON.parse(xhr.responseText) // 返回结果
                resolve(file.path)
              } else {
                this.uploadingProgress = uploadedChunk * chunkSize / blob.size
              }
            }
            if(xhr.status >= 400){
              this.uploading = false
              this.uploadFailedFlag = true
            }
          }
          xhr.onerror = (evt) => { // 上传失败回调
            this.uploading = false
            this.uploadFailedFlag = true
            resolve()
          }
          xhr.send(fd);
        }
      })
    },
    initFileName: function(fileName){
      return fileName.split('.')
    },
  }
}
</script>
<style lang="less" scoped>
.fileboxheader {
  position: relative;
  width: @fileboxw;
  height: @filebox;
  line-height: @filebox;

  border: @filexborder;
  background: @bluebtn;
  > span {
    color: @whitee;
    padding-left: @filepadding;
  }
  > img {
    position: absolute;
    right: @filepadding;
    top: 50%;
    width: @checkringht;
    transform: translateY(-50%);
  }
}
.fileboxmain {
  background: @globalback;
  width: @fileboxw;
  height: @fileboxmax;
  border: @filexborder;

  display: flex;
  justify-content: center;
  align-items: center;
}
.fileboxbox {
  cursor: pointer;
  text-align: center;
}
.fileboxtext {

  color: @bluebtn;
  font-size: @checkringht;
}
</style>
